export const stepsOfertaData = [
    {
        title: 'Achou uma boa oferta?',
        description: 'Clique em "Ver Oferta". Ao clicar, uma janela será aberta.',
        imageSrc: 'https://static.meucupom.com/media/2026%20-%20Updates/novo-site/oferta_passo_1.png',
    },
    {
        title: 'Ir para o site',
        description: 'Dentro da janela, clique no botão "Ver Oferta" para entrar na página da loja.',
        imageSrc: 'https://static.meucupom.com/media/2026%20-%20Updates/novo-site/oferta_passo_2.png',
    },
];